export default function ColorPalette({
  addToSaved,
  savedColors,
  copyColor,
  copiedColor,
  currentPalette,
}) {
  return (
    <div className="color-palette">
      {currentPalette.map((colorHex) => (
        <div key={colorHex} className="color-card">
          <div
            className="color-display"
            style={{ backgroundColor: colorHex }}
          ></div>
          <div className="color-info">
            <p className="hex-code">{colorHex}</p>
            <div className="color-actions">
              <button className="icon-btn" onClick={() => copyColor(colorHex)}>
                {copiedColor === colorHex ? "✓" : "📋"}
              </button>
              <button
                onClick={() => addToSaved(colorHex)}
                className={`icon-btn ${
                  savedColors.includes(colorHex) ? "saved" : ""
                }`}
              >
                {savedColors.includes(colorHex) ? "❤️" : "🤍"}
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
